<template>
  <div class="createdCharts clearfix" v-loading.fullscreen.lock="loadingMark" element-loading-text="正在等待图表生成 ...">
    <div class="charts_header clearfix">
      <!--<div class="closediv" @click="close"><span class="close"></span></div>-->
      <div class="header_content clearfix">
        <div class="left">
          报表 {{common.timestampToTime(dataTime.getTime())}}
        </div>
        <div class="right">
          <div class="right_left" id="createdCharts_header_right">
            <el-radio-group v-model="radio" @change="chartsTypeChange">
              <el-radio :label="1">图形+表格</el-radio>
              <el-radio :label="2">图形</el-radio>
              <el-radio :label="3">表格</el-radio>
            </el-radio-group>
          </div>
          <div class="right_right">
            <div class="export" @click="exportClick()">导出</div>
            <div class="print" @click="printClick()">打印</div>
          </div>
        </div>
      </div>
    </div>
    <div class="charts_content clearfix" ref="fatherPrint">
      <div class="overAuto clearfix" id="print" ref="print">
        <!--图表-->
        <div class="Figure clearfix" v-show="radio == 1 || radio == 2">
          <div class="figCharts pielist clearfix" v-for="(item,index) in pieList">
            <div class="title">
              <div class="title-border"></div>
              {{item.name}}
            </div>
            <div class="fig_content" :ref="'pieList'+item.id"></div>
          </div>
          <div class="figCharts clearfix" v-for="(item,index) in barList">
            <div class="title">
              <div class="title-border"></div>
              {{item.name}}
            </div>
            <div class="fig_content" :ref="'barList'+item.id"></div>
          </div>
          <div class="figCharts clearfix" v-for="(item,index) in lineList">
            <div class="title">
              <div class="title-border"></div>
              {{item.name}}
            </div>
            <div class="fig_content" :ref="'lineList'+item.id"></div>
          </div>

        </div>

        <!--表格-->
        <div class="Table clearfix" v-show="radio == 1 || radio == 3">
          <div class="tableCharts clearfix" v-for="(item,index) in tableList">
            <div class="title">
              <div class="title-border"></div>
              {{item.name}}
            </div>
            <div class="table_content" :ref="'tableList'+item.id">
              <el-table ref="multipleTable" :highlight-current-row="true" :data="item.tableData.data"
                tooltip-effect="dark">
                <el-table-column width="40">
                </el-table-column>
                <el-table-column prop="address" width="200" label="时间">
                  <template slot-scope="scope">
                    <div style="letter-spacing: 0.5px;">{{ changeTime2(scope.row.createdTime,item.timeWindow)}}</div>
                  </template>
                </el-table-column>
                <el-table-column width="200" v-for="(itemData,index) in item.tableData.attr" :key="index+Math.random()"
                  prop="address" :label="itemData.nameA" v-if="itemData.nameA != ''">
                  <template slot-scope="scope">{{ showTableData(scope.row[itemData.nameA],itemData.unit)}}</template>
                </el-table-column>
                <el-table-column width="200" v-for="(itemData,index) in item.tableData.attr" :key="index+Math.random()"
                  prop="address" :label="itemData.nameB" v-if="itemData.nameB != ''">
                  <template slot-scope="scope">{{ showTableData(scope.row[itemData.nameB],itemData.unit)}}</template>
                </el-table-column>
                <el-table-column width="200" v-for="(itemData,index) in item.tableData.attr" :key="index+Math.random()"
                  prop="address" :label="itemData.nameC" v-if="itemData.nameC != ''">
                  <template slot-scope="scope">{{ showTableData(scope.row[itemData.nameC],itemData.unit)}}</template>
                </el-table-column>
                <el-table-column>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--<img :src="img" id="printa" />-->
  </div>
</template>

<script>
  import html2canvas from 'html2canvas' // 转图片打印需要先安装html2Canvas和print-js
  import printJS from 'print-js'
  var XLSX = require('xlsx')
  import {
    mapState
  } from 'vuex';
  export default {
    name: 'createdCharts',
    props: {

    },
    data() {
      return {
        loadingMark: false, //loding加载开关
        dataTime: new Date(), //当前时间
        img: '',
        deviceList: [],
        printObj: {
          id: 'printMe',
        },
        DataSetList: [{
          id: 0,
          name: '测试饼图',
          chartType: 1,
        }, {
          id: 1,
          name: '测试柱状图',
          chartType: 2,
        }, {
          id: 2,
          name: '测试折线图',
          chartType: 3,
        }, {
          id: 3,
          name: '测试表格',
          chartType: 4,
        }, {
          id: 4,
          name: '测试表格',
          chartType: 4,
        }, {
          id: 5,
          name: '测试表格',
          chartType: 4,
        }, {
          id: 6,
          name: '测试表格',
          chartType: 1,
        }, {
          id: 3,
          name: '测试表格',
          chartType: 4,
        }, {
          id: 4,
          name: '测试表格',
          chartType: 4,
        }, {
          id: 5,
          name: '测试表格',
          chartType: 4,
        }, {
          id: 6,
          name: '测试表格',
          chartType: 1,
        }], //存放所有数据集列表

        radio: 1, //页面要显示的报表类型

        //用于展示 数组
        pieList: [],
        barList: [],
        lineList: [],
        tableList: [],

        /*配置图表颜色*/
        color: ['#00CCCD', '#407FFF', '#E15D68', '#A682E6', '#F29961'],

        ProductFeature: [],
      }
    },
    created() {
      this.$parent.ChangeHeaderShow();
      if (JSON.parse(sessionStorage.getItem('DataSetList')).length > 0) {
        this.DataSetList = JSON.parse(sessionStorage.getItem('DataSetList'));
      }
      // console.log(JSON.parse(sessionStorage.getItem('DataSetList')))
    },
    computed: {
      ...mapState("defaultChartsOptions", {
        system_options: 'system_options',
        ChartsDataLength: 'ChartsDataLength'
      }),
      showTableData() {
        return (value, unit) => {
          if (value == null) {
            return '-'
          } else {
            unit = unit ? unit : ''
            return this.common.fmoneyNoFix(value) + ' ' + unit
          }
        }
      },
    },
    mounted() {
      let self = this;
      this.initDataSet();
      document.title = `报表 ${self.common.timestampToTime(self.dataTime.getTime())}`; // 动态修改网站标题
    },
    components: {

    },
    methods: {

      /*初始化*/
      async initDataSet() {
        var self = this;
        this.loadingMark = true;
        for (let list of this.DataSetList) {
          if (list.chartType == 1) {
            /*饼图*/
            this.pieList.push(list)
            this.tableList.push(list)
          } else if (list.chartType == 2) {
            /*柱状图*/
            this.barList.push(list)
            this.tableList.push(list)
          } else if (list.chartType == 3) {
            /*折线图*/
            this.lineList.push(list)
            this.tableList.push(list)
          } else if (list.chartType == 4) {
            /*文本标签*/
            this.tableList.push(list)
          }
        }
        //图表无需等待 直接加载
        await this.initTable();
        /*等待之后 再调用初始化 图表 */
        this.$nextTick(async () => {
          await this.initPie();
          await this.initBar();
          await this.initLine();
          this.loadingMark = false;
        })
      },

      changeTime2(now,type){
        if (now == "" || now == null || typeof now == 'string') {
          return
        }
        now = new Date(Number(now))
        let year = now.getFullYear(); //取得4位数的年份
        let month = now.getMonth() + 1; //取得日期中的月份，其中0表示1月，11表示12月
        let date = now.getDate(); //返回日期月份中的天数（1到31）
        if (month < 10) {
          month = "0" + month
        }
        if (date < 10) {
          date = "0" + date
        }
        if(type==1){
          let hour = now.getHours(); //返回日期中的小时数（0到23）
          let minute = now.getMinutes(); //返回日期中的分钟数（0到59）
          if (hour < 10) {
            hour = "0" + hour
          }
          if (minute < 10) {
            minute = "0" + minute
          }
          return `${year}-${month}-${date} ${hour}:${minute}`
        }else if(type==2){
          let hour = now.getHours(); //返回日期中的小时数（0到23）
          if (hour < 10) {
            hour = "0" + hour
          }
          return `${year}-${month}-${date} ${hour}`
        }else if(type > 2){
          return `${year}-${month}-${date}`
        }
      },

      initPie() {
        let self = this;
        return new Promise(resolve => {
          if (this.pieList.length == 0) {
            resolve();
            return;
          }
          let listIndex = 0;
          for (let obj of this.pieList) {
            //当前图表dom
            let dom = this.$refs['pieList' + obj.id][0];
            //初始化图表
            let charts = this.$echarts.init(dom);
            /*
             * 饼图 可以有多条数据源 但是只获取各个数据源下data的最后一条value的第一个值
            	obj => 数据集对象 选中的数据集图表类型为饼图
            */
            //修正系数
            if (obj.ratio || Number(obj.ratio) == 0) {
              var ratio = obj.ratio
            } else {
              var ratio = 1;
            }
            //保留小数
            if (obj.place) {
              var place = obj.place
            } else {
              var place = null;
            }
            var data = [];

            /*获取数据集历史数据*/
            self.get('/Dataset/getReport', {
              id: obj.id, //数据集编号
              code: obj.groupCode //分组或企业编码
            }).then(async (res) => {
              if (res.success == true) {
                let resIndex = 0;
                if (JSON.stringify(res.result) == '{}') {
                  listIndex++;
                  if (listIndex == self.pieList.length) {
                    resolve();
                  }
                } else {
                  //									for(let result of res.result) {
                  data = await self.PieGetByDeviceCode(obj, res.result, ratio, place)
                  //data = data.concat(dataResult)
                  //										resIndex++
                  //										if(resIndex == res.result.length) {
                  charts.setOption({
                    tooltip: {
                      enterable: true,
                      transitionDuration: 0,
                      trigger: 'item',
                      show: obj.showData,
                      formatter: function(params) {
                        return params.data.showName + " " + self.common.fmoneyNoFix(params.data.value) +
                          ' ' + params.data.unit
                      }
                    },
                    legend: {
                      show: obj.showLegend,
                      type: 'scroll',
                      orient: 'vertical',
                      // top: 'middle',
                      bottom: '10%',
                      right: '0%',
                      selectedMode: false,
                      icon: 'rect',
                      borderRadius: 0,
                      itemGap: 15,
                      itemWidth: 11,
                      itemHeight: 11,
                      textStyle: {
                        borderRadius: 0,
                        padding: [2, 0, 0, 8]
                      },
                      formatter: function(params) {
                        return params.split('/')[0]
                      }
                    },
                    color: self.color,
                    series: [{
                      type: 'pie',
                      radius: ['10%', '50%'],
                      center: ['45%', '40%'],
                      label: {
                        show: obj.showLabel,
                        formatter: function(params) {
                          return params.data.showName
                        }
                      },
                      labelLine: {
                        length: 20,
                        length2: 20
                      },
                      selectedMode: 'single',
                      selectedOffset: 0,
                      data: data,
                      emphasis: {
                        itemStyle: {
                          shadowBlur: 10,
                          shadowOffsetX: 0,
                          shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                      },
                      avoidLabelOverlap: true,
                      minAngle: 5,
                    }, {
                      type: 'pie',
                      radius: ['10%', '50%'],
                      center: ['45%', '40%'],
                      label: {
                        show: obj.showPercent,
                        position: 'inner',
                        formatter: '{d}%',
                        fontSize: 13,
                      },
                      hoverAnimation: false,
                      data: data,
                      avoidLabelOverlap: true,
                      minAngle: 5,
                    }]
                  })
                  listIndex++;
                  if (listIndex == self.pieList.length) {
                    resolve();
                  }
                  //										}
                  //									}
                }

              } else {
                resolve();
              }
            })
          }
        })
      },

      initBar() {
        let self = this;
        return new Promise(resolve => {
          if (this.barList.length == 0) {
            resolve();
            return;
          }
          let listIndex = 0;
          for (let obj of this.barList) {
            //当前图表dom
            let dom = this.$refs['barList' + obj.id][0];
            //初始化图表
            let charts = this.$echarts.init(dom);
            /*
             * 柱状图可以显示多个数据源
            	obj => 数据集对象 选中的数据集图表类型为柱状图
            */
            if (obj.ratio || Number(obj.ratio) == 0) {
              var ratio = obj.ratio
            } else {
              var ratio = 1;
            }
            //保留小数
            if (obj.place) {
              var place = obj.place
            } else {
              var place = null;
            }
            /*获取数据集历史数据*/
            self.get('/Dataset/getReport', {
              id: obj.id, //数据集编号
              code: obj.groupCode //分组或企业编码
            }).then(async (res) => {
              if (res.success == true) {
                if (JSON.stringify(res.result) == '{}') {
                  listIndex++;
                  if (listIndex == self.barList.length) {
                    resolve();
                  }
                } else {
                  var Objreturn = {};
                  /*if(obj.function == 'pass') {
                  	//当函数为透传时 有多条数据源
                  	Objreturn = await self.BarGetByDeviceCodeOther(obj, res.result, ratio, place)
                  } else {
                  	Objreturn = await self.BarGetByDeviceCodeOther(obj, res.result, ratio, place)
                  }*/
                  Objreturn = await self.BarGetByDeviceCode(obj, res.result, ratio, place)
                  let series = Objreturn.series;
                  let categoryData = Objreturn.categoryData;
                  charts.setOption({
                    color: self.color,
                    legend: {
                      show: obj.showLegend,
                      type: "scroll",
                      orient: 'horizontal',
                      // top: 'middle',
                      top: '0%',
                      right: '10%',
                      selectedMode: false,
                      icon: 'rect',
                      borderRadius: 0,
                      itemGap: 20,
                      itemWidth: 11,
                      itemHeight: 11,
                      textStyle: {
                        borderRadius: 0,
                        padding: [2, 0, 0, 8]
                      },
                      formatter: function(name) {
                        return name.split('0.')[0]
                      },
                    },
                    tooltip: {
                      enterable: true,
                      transitionDuration: 0,
                      trigger: 'axis',
                      axisPointer: {
                        type: 'shadow'
                      },
                      formatter: function(params) {
                        //console.log(params)
                        let name = params[0].name;
                        let div = '';
                        for (let a of params) {
                          if (a.data == '-') {
                            div += '<br>' + a.marker + a.seriesName.split('0.')[0] + " " + '-';
                          } else {
                            div += '<br>' + a.marker + a.seriesName.split('0.')[0] + " " + self.common
                              .fmoneyNoFix(a.data) + ' ' + a.seriesName.split('-')[1];
                          }
                        }
                        return name + div;
                      }
                    },
                    grid: {
                      top: 10,
                      bottom: 90,
                      right: 10,
                      left: 70
                    },
                    xAxis: {
                      data: categoryData,
                      silent: false,
                      type: 'category',
                      splitNumber: 10,
                      splitLine: {
                        show: false
                      },
                      axisTick: {
                        show: false
                      },
                      splitArea: {
                        show: false
                      },
                      axisLabel: {
                        padding: [5, 0, 0, 5],
                        lineHeight: 15,
                        textStyle: {
                          fontSize: 12,
                          color: '#333333'
                        }
                      },
                      axisLine: {
                        lineStyle: {
                          color: '#227082'
                        }
                      }
                    },
                    yAxis: {
                      max: function(value) {
                        return value.max
                      },
                      nameTextStyle: {
                        color: '#373737',
                        align: 'right',
                        padding: [0, 5, 10, 0]
                      },
                      type: 'value',
                      boundaryGap: ['0', '0.1'],
                      axisTick: {
                        show: false
                      },
                      splitArea: {
                        show: false
                      },
                      splitLine: {
                        show: false
                      },
                      axisLabel: {
                        padding: [0, 6, 0, 0],
                        textStyle: {
                          fontSize: 12,
                          color: '#333333'
                        }
                      },
                      axisLine: {
                        lineStyle: {
                          color: '#227082'
                        }
                      }
                    },
                    series: series
                  })
                  listIndex++;
                  if (listIndex == self.barList.length) {
                    resolve();
                  }
                }

              } else {
                resolve();
              }
            })
          }
        })
      },

      initLine() {
        let self = this;
        return new Promise(resolve => {
          if (this.lineList.length == 0) {
            resolve();
            return;
          }
          let listIndex = 0;
          for (let obj of this.lineList) {
            //当前图表dom
            let dom = this.$refs['lineList' + obj.id][0];
            //初始化图表
            let charts = this.$echarts.init(dom);
            /*
             * 折线图可以显示多条数据源 且数据源下data的value是值为三个的数组 如："value": [1,3,5]
            	obj => 数据集对象 选中的数据集图表类型为折线图
            */
            if (obj.ratio || Number(obj.ratio) == 0) {
              var ratio = obj.ratio
            } else {
              var ratio = 1;
            }
            //保留小数
            if (obj.place) {
              var place = obj.place
            } else {
              var place = null;
            }

            /*获取数据集历史数据*/
            self.get('/Dataset/getReport', {
              id: obj.id, //数据集编号
              code: obj.groupCode //分组或企业编码
            }).then(async (res) => {
              if (res.success == true) {
                if (JSON.stringify(res.result) == '{}') {
                  listIndex++;
                  if (listIndex == self.lineList.length) {
                    resolve();
                  }
                } else {
                  var Objreturn = await self.LineGetByDeviceCode(obj, res.result, ratio, place)

                  let series = Objreturn.series
                  charts.setOption({
                    color: self.color,
                    legend: {
                      show: obj.showLegend,
                      type: 'scroll',
                      orient: 'horizontal',
                      // top: 'middle',
                      top: '-5',
                      right: '10%',
                      selectedMode: false,
                      icon: 'rect',
                      borderRadius: 0,
                      itemGap: 15,
                      itemWidth: 11,
                      itemHeight: 11,
                      textStyle: {
                        borderRadius: 0,
                        padding: [2, 0, 0, 8]
                      },
                      formatter: function(name) {
                        return name.split('0.')[0]
                      }
                    },
                    tooltip: {
                      confine: true,
                      transitionDuration: 0,
                      backgroundColor: '#FFFFFF',
                      borderWidth: 0,
                      snap: false,
                      trigger: 'axis',
                      showContent: true,
                      axisPointer: {
                        z: 1,
                        animation: true,
                        label: {

                        },
                        lineStyle: {
                          color: 'transparent',
                        },
                      },
                      textStyle: {
                        align: 'left',
                        color: '#292929'
                      },
                      extraCssText: 'font-size: 15px;line-height:30px;padding: 9px 19px;text-align:left;border-radius: 4px 4px 4px 4px;color: #2d2d2d;',
                      formatter: function(params) {
                        //console.log(params)
                        let name = params[0].name.split(":")[0] + ":" + params[0].name.split(":")[1]
                          .split(':')[0]
                        let div = '';
                        for (let a of params) {
                          if (a.data.value[1] == '-') {
                            div += '<br>' + a.marker + a.seriesName.split('0.')[0] + " " + '-';
                          } else {
                            div += '<br>' + a.marker + a.seriesName.split('0.')[0] + " " + self.common
                              .fmoneyNoFix(a.data.value[1]) + ' ' + a.data.unit;
                          }
                        }
                        return name + div;
                      }
                    },
                    grid: {
                      left: '3%',
                      right: '4%',
                      bottom: '5%',
                      top: '15%',
                      containLabel: true
                    },
                    xAxis: {
                      type: 'time',
                      boundaryGap: false,
                      splitNumber: 10,
                      axisLabel: {
                        padding: [5, 0, 0, 0],
                        lineHeight: 15,
                        textStyle: {
                          fontSize: 12,
                          color: '#2C2C2C'
                        },
                        /*formatter: function(value, index) {
                        	var date = new Date(value);
                        	let y = date.getFullYear(),
                        		m = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1),
                        		d = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
                        	return y + '-' + m + '-' + d;
                        },*/
                      },
                      splitLine: {
                        show: false,
                      },
                      axisLine: {
                        lineStyle: {
                          color: '#C9C9C9'
                        },
                        onZero: false,
                      },
                      axisTick: {
                        show: false,
                      }
                    },
                    yAxis: {
                      max: function(value) {
                        return value.max
                      },
                      min: function(value) {
                        return value.min
                      },
                      gridIndex: 0,
                      axisTick: {
                        show: false,
                      },
                      axisLabel: {
                        padding: [5, 7, 0, 0],
                        textStyle: {
                          fontSize: 12,
                          color: '#292929'
                        }
                      },
                      axisLine: {
                        show: false,
                      },
                      splitLine: {
                        lineStyle: {
                          type: 'solid',
                          color: 'rgba(102,198,231,.2)'
                        }
                      },
                    },
                    series: series
                  })
                  listIndex++;
                  if (listIndex == self.lineList.length) {
                    resolve();
                  }
                }

              } else {
                resolve();
              }
            })
          }
        })
      },

      initTable() {
        let self = this;
        return new Promise(resolve => {
          if (this.tableList.length == 0) {
            resolve();
            return;
          }
          let listIndex = 0;
          for (let obj of this.tableList) {
            //初始化表格
            obj.tableData = {
              attr: [],
              data: [],
            };
            /*
             * 表格 可以有多条数据源 即多个tableData.attr	时间一致
            	obj => 数据集对象 选中的数据集图表类型为文本标签
             */
            if (obj.ratio || Number(obj.ratio) == 0) {
              var ratio = obj.ratio
            } else {
              var ratio = 1;
            }
            //保留小数
            if (obj.place) {
              var place = obj.place
            } else {
              var place = null;
            }

            var attr = [];
            var data = [];
            /*获取数据集历史数据*/
            self.get('/Dataset/getReport', {
              id: obj.id, //数据集编号
              code: obj.groupCode //分组或企业编码
            }).then(async (res) => {
              if (res.success == true) {
                if (JSON.stringify(res.result) == '{}') {
                  listIndex++;
                  if (listIndex == self.tableList.length) {
                    resolve();
                  }
                } else {
                  let Objreturn = await self.TableGetByDeviceCode(obj, res.result, ratio, place);
                  attr = Objreturn.attr;
                  data = Objreturn.data;
                  obj.tableData = {
                    attr: attr,
                    data: data
                  }
                  listIndex++;
                  if (listIndex == self.tableList.length) {
                    resolve();
                  }
                }

              } else {
                resolve();
              }
            })
          }
          console.log(this.tableList)
        })
      },

      /*通过 设备Code/属性code 获取物模型对象*/
      getProductFeature(deviceCode, propertyCode) {
        /* 同步
         * deviceCode => 设备code
         * propertyCode => 属性code
         * 返回物模型对象
         * */
        let self = this;
        return new Promise((resolve) => {
          let FeatureArr = self.ProductFeature.filter(item => item.deviceCode == deviceCode)
          if (FeatureArr.length == 0) {
            self.get('/ProductFeature/getByDeviceCode', {
              code: deviceCode, //设备code
            }).then((resPro) => {
              if (resPro.success == true) {
                let dataList = JSON.parse(resPro.result).properties;
                self.ProductFeature.push({
                  deviceCode: deviceCode,
                  properties: dataList
                })
                resolve(dataList.filter(item => item.identifier == propertyCode)[0])
                return;
              }
            })
          } else {
            resolve(FeatureArr[0].properties.filter(item => item.identifier == propertyCode)[0])
            return;
          }
        })
      },
      /*通过 设备Code/属性code 获取物模型对象*/
      getDevice(deviceCode) {
        /* 同步
         * deviceCode => 设备code
         * 返回设备名称
         * */
        let self = this;
        return new Promise((resolve) => {
          if (!deviceCode) {
            resolve('')
            return;
          }
          let device = self.deviceList.filter(item => item.code == deviceCode)
          if (device.length == 0) {
            self.get('/Device/getByCode', {
              code: deviceCode, //设备code
            }).then((resPro) => {
              if (resPro.success == true) {
                let obj = resPro.result;
                self.deviceList.push(obj)
                resolve(obj.name)
                return;
              } else {
                resolve('')
                return;
              }
            })
          } else {
            resolve(device[0].name)
            return;
          }
        })
      },
      /*通过报警id获取报警对象*/
      getDictById(id) {
        /* 同步
         * id => 报警类别id
         * 返回报警对象名称
         * */
        let self = this;
        return new Promise((resolve) => {
          self.get('/Dict/getListByType', {
            type: 2, //报警分类
          }).then((resPro) => {
            if (resPro.success == true) {
              let obj = resPro.result.filter(item => item.id == Number(id))[0];
              if (!obj) {
                resolve('')
              } else {
                resolve(obj.name);
              }
            }
          })
        })
      },

      /*通过产品Code获取产品对象*/
      getProductByCode(code) {
        /* 同步
         * code => 产品code
         * 返回产品对象名称
         * */
        let self = this;
        return new Promise((resolve) => {
          self.get('/Product/getList').then((resPro) => {
            if (resPro.success == true) {
              let obj = resPro.result.filter(item => item.code == code)[0];
              if (!obj) {
                resolve('')
              } else {
                resolve(obj.name);
              }
            }
          })
        })
      },

      /*饼图 解决异步问题 调用产品物模型*/
      PieGetByDeviceCode(obj, result, ratio, place) {
        /*
         * obj => 当前数据集对象
         * result => 当前数据集历史记录
         * ratio => 当前数据集修正系数
         * place => 当前数据集保留小数位数
         */
        let self = this;
        return new Promise(async (resolve) => {
          /*没数据情况下*/
          if (JSON.stringify(result) == '[]' || JSON.stringify(result) == '{}') {
            resolve([])
            return;
          }

          let data = [];
          /*总配置*/
          let resultIndex = 0;
          /*将数据集历史记录每条数据的value值作为饼图的值*/
          for (let resultList of result) {
            let featureList;
            let unit;
            let nameA = '';
            let nameB = '';
            let nameC = '';
            let name = '';
            if (resultList.deviceCode == 'SYSTEM_PROPERTY') {
              /*判断数据集历史记录的单个对象是否为系统属性*/
              unit = '';
              if (resultList.propertyCode.indexOf('_alarm_category_') != -1) {
                name = await self.getDictById(resultList.propertyCode.split('_alarm_category_')[1]);
              } else if (resultList.propertyCode.indexOf('_device_product_') != -1) {
                name = await self.getProductByCode(resultList.propertyCode.split('_device_product_')[1]);
              } else {
                name = self.system_options.filter(item => item.id == resultList.propertyCode)[0].name;
              }
            } else {
              /*不为系统属性时*/
              /*获取TSL 获取 数据属性名称*/
              featureList = await self.getProductFeature(resultList.deviceCode, resultList.propertyCode);
              let deviceName = await self.getDevice(resultList.deviceCode);
              name = deviceName ? featureList.name + '/' + deviceName : featureList.name;
              unit = featureList.dataType.specs.unit
            }
            /*配置图例名称后缀*/
            if (obj.function == 'pass') {
              nameA = name
            }else if (obj.function == 'add') {
              //nameA = '-求和'
              nameA = ' ';
            } else if (obj.function == 'growth') {
              unit = obj.unit;
              nameA = '增长量: '+name
              nameB = '增长率: '+name
            } else if (obj.function == 'time') {
              //nameA = '-持续时长'
              nameA = ' ';
            } else if (obj.function == 'sample') {
              unit = obj.unit;
              nameA = '最大值：'+name
              nameB = '最小值：'+name
              nameC = '平均值：'+name
            }
            if (!unit) {
              unit = '';
            }

            let indexForI = 0
            let valueDataA = []; //value[0]值
            let valueDataB = []; //value[1]值
            let valueDataC = []; //value[2]值

            /*数据处理 ...遍历柱状图数量 ...*/
            for (let i of resultList.data[0].value) {
              let name;
              if (indexForI == 0) {
                name = nameA;
              } else if (indexForI == 1) {
                name = nameB;
              } else if (indexForI == 2) {
                name = nameC;
              }
              data.push({
                name: name + '/' + Math.random(),
                showName: name,
                propertyCode: name,
                unit: unit,
                value: Number((i * ratio).toFixed(place))
              })
              indexForI++;
            }
            resultIndex++;
            if (resultIndex == result.length) {
              resolve(data)
            }
          }



          /*将数据集历史记录最后一条数据的value值作为饼图的值 (错误)*/
          /*for(let i of result.data[result.data.length - 1].value){
          	let name;
          	if(indexForI == 0){
          		name = nameA;
          	}else if(indexForI == 1){
          		name = nameB;
          	}else if(indexForI == 2){
          		name = nameC;
          	}
          	data.push({
          		name: name + '/' +Math.random(),
          		showName: name,
          		propertyCode: name,
          		unit: unit,
          		value: Number((i * ratio).toFixed(place))
          	})
          	indexForI++;
          }
          resolve(data)*/
        })

      },

      /*柱状图 解决异步问题 调用产品物模型*/
      BarGetByDeviceCode(obj, result, ratio, place) {
        /*
         * obj => 当前数据集对象
         * result => 当前数据集历史记录对象(有多个)
         * ratio => 当前数据集修正系数
         * place => 当前数据集保留小数位数
         * 该函数返回三个值
         * series,categoryData
         * =>
         * 图表series,x轴数据(时间)categoryData
         */
        let self = this;
        return new Promise(async (resolve) => {
          let series = [];
          let categoryData = [];

          /*没数据情况下*/
          if (JSON.stringify(result) == '[]' || JSON.stringify(result) == '{}') {
            resolve({
              series: [],
              categoryData: []
            })
            return;
          }

          /*配置x轴时间*/
          for (let res_data of result[0].data) {
            //配置x轴时间
            let date = new Date(res_data.time);
            categoryData.push(self.$echarts.format.formatTime('yyyy-MM-dd\nhh:mm:ss', date))
          }

          /*总配置*/
          let resultIndex = 0;
          for (let resultList of result) {
            let featureList;
            let unit;
            let nameA = '';
            let nameB = '';
            let nameC = '';
            let name = '';
            if (resultList.deviceCode == 'SYSTEM_PROPERTY') {
              /*判断数据集历史记录的单个对象是否为系统属性*/
              unit = '';
              if (resultList.propertyCode.indexOf('_alarm_category_') != -1) {
                name = await self.getDictById(resultList.propertyCode.split('_alarm_category_')[1]);
              } else if (resultList.propertyCode.indexOf('_device_product_') != -1) {
                name = await self.getProductByCode(resultList.propertyCode.split('_device_product_')[1]);
              } else {
                name = self.system_options.filter(item => item.id == resultList.propertyCode)[0].name;
              }
            } else {
              /*不为系统属性时*/
              /*获取TSL 获取 数据属性名称*/
              featureList = await self.getProductFeature(resultList.deviceCode, resultList.propertyCode);
              let deviceName = await self.getDevice(resultList.deviceCode);
              name = deviceName ? featureList.name + '/' + deviceName : featureList.name;
              unit = featureList.dataType.specs.unit
            }
            /*配置图例名称后缀*/
            if (obj.function == 'pass') {
              nameA = name
            }else if (obj.function == 'add') {
              //nameA = '-求和'
              nameA = ' ';
            } else if (obj.function == 'growth') {
              unit = obj.unit;
              nameA = '增长量: '+name
              nameB = '增长率: '+name
            } else if (obj.function == 'time') {
              //nameA = '-持续时长'
              nameA = ' ';
            } else if (obj.function == 'sample') {
              unit = obj.unit;
              nameA = '最大值：'+name
              nameB = '最小值：'+name
              nameC = '平均值：'+name
            }
            if (!unit) {
              unit = '';
            }
            let index = 0; //当前数据源长度索引
            let valueDataA = []; //value[0]值
            let valueDataB = []; //value[1]值
            let valueDataC = []; //value[2]值
            /*数据处理 ...遍历柱状图数量 ...*/
            for (let dataList of resultList.data) {
              let value_index = 0; //当前数据源中的value长度索引
              for (let value of dataList.value) {
                if (value_index == 0) {
                  if (value == null) {
                    valueDataA.push('-')
                  } else {
                    valueDataA.push(Number((value * ratio).toFixed(place)))
                  }
                } else if (value_index == 1) {
                  if (value == null) {
                    valueDataB.push('-')
                  } else {
                    valueDataB.push(Number((value * ratio).toFixed(place)))
                  }
                } else if (value_index == 2) {
                  if (value == null) {
                    valueDataC.push('-')
                  } else {
                    valueDataC.push(Number((value * ratio).toFixed(place)))
                  }
                }
                value_index++;
              }

              index++;
              if (index == resultList.data.length) {
                /*一组数据源 需要显示的柱状条数*/
                /*当前数据源最后一次循环时 将数据添加进图表中*/
                let seriesObj = {}; //临时存储
                let length_index = 0; //当前数据源中的value长度索引
                for (let length of dataList.value) {
                  if (length_index == 0) {
                    seriesObj = {
                      name: nameA + Math.random() + '-' + unit,
                      type: 'bar',
                      data: valueDataA,
                      barGap: '35%',
                      large: true,
                    }
                  } else if (length_index == 1) {
                    seriesObj = {
                      name: nameB + Math.random() + '-' + unit,
                      type: 'bar',
                      data: valueDataB,
                      barGap: '35%',
                      large: true,
                    }
                  } else if (length_index == 2) {
                    seriesObj = {
                      name: nameC + Math.random() + '-' + unit,
                      type: 'bar',
                      data: valueDataC,
                      barGap: '35%',
                      large: true,
                    }
                  }
                  length_index++;
                  series.push(seriesObj)
                }
              }
            }
            resultIndex++;
            if (resultIndex == result.length) {
              resolve({
                series: series,
                categoryData: categoryData,
              })
            }
          }
        })
      },

      /*折线图 解决异步问题 调用产品物模型*/
      LineGetByDeviceCode(obj, result, ratio, place) {
        /*
         * obj => 当前数据集对象
         * result => 当前数据集历史记录对象(有多个)
         * ratio => 当前数据集修正系数
         * place => 当前数据集保留小数位数
         * 该函数返回一个值
         * series => 图表series
         */
        let self = this;
        return new Promise(async (resolve) => {
          let series = [];

          /*没数据情况下*/
          if (JSON.stringify(result) == '[]' || JSON.stringify(result) == '{}') {
            resolve({
              series: []
            })
            return;
          }

          /*总配置*/
          let resultIndex = 0;
          for (let resultList of result) {
            let featureList;
            let unit;
            let nameA = '';
            let nameB = '';
            let nameC = '';
            let name = '';
            if (resultList.deviceCode == 'SYSTEM_PROPERTY') {
              /*判断数据集历史记录的单个对象是否为系统属性*/
              unit = '';
              if (resultList.propertyCode.indexOf('_alarm_category_') != -1) {
                name = await self.getDictById(resultList.propertyCode.split('_alarm_category_')[1]);
              } else if (resultList.propertyCode.indexOf('_device_product_') != -1) {
                name = await self.getProductByCode(resultList.propertyCode.split('_device_product_')[1]);
              } else {
                name = self.system_options.filter(item => item.id == resultList.propertyCode)[0].name;
              }
            } else {
              /*不为系统属性时*/
              /*获取TSL 获取 数据属性名称*/
              featureList = await self.getProductFeature(resultList.deviceCode, resultList.propertyCode);
              let deviceName = await self.getDevice(resultList.deviceCode);
              name = deviceName ? featureList.name + '/' + deviceName : featureList.name;
              unit = featureList.dataType.specs.unit
            }
            /*配置图例名称后缀*/
            if (obj.function == 'pass') {
              nameA = name
            }else if (obj.function == 'add') {
              //nameA = '-求和'
              nameA = ' ';
            } else if (obj.function == 'growth') {
              unit = obj.unit;
              nameA = '增长量: '+name
              nameB = '增长率: '+name
            } else if (obj.function == 'time') {
              //nameA = '-持续时长'
              nameA = ' ';
            } else if (obj.function == 'sample') {
              unit = obj.unit;
              nameA = '最大值：'+name
              nameB = '最小值：'+name
              nameC = '平均值：'+name
            }
            if (!unit) {
              unit = '';
            }
            let index = 0; //当前数据源的长度索引
            let valueDataA = []; //value[0]值
            let valueDataB = []; //value[1]值
            let valueDataC = []; //value[2]值

            /*数据处理 ...遍历折线图数量 ...*/
            for (let dataList of resultList.data) {
              let value_index = 0; //当前数据源中的value长度索引
              for (let value of dataList.value) {
                if (value_index == 0) {
                  if (value == null) {
                    valueDataA.push(self.randomData(unit, dataList.time, null))
                  } else {
                    valueDataA.push(self.randomData(unit, dataList.time, (value * ratio).toFixed(place)))
                  }
                } else if (value_index == 1) {
                  if (value == null) {
                    valueDataB.push(self.randomData(unit, dataList.time, null))
                  } else {
                    valueDataB.push(self.randomData(unit, dataList.time, (value * ratio).toFixed(place)))
                  }
                } else if (value_index == 2) {
                  if (value == null) {
                    valueDataC.push(self.randomData(unit, dataList.time, null))
                  } else {
                    valueDataC.push(self.randomData(unit, dataList.time, (value * ratio).toFixed(place)))
                  }
                }
                value_index++;
              }

              index++;
              if (index == resultList.data.length) {
                /*一组数据源 需要显示的折线条数*/
                /*当前数据源最后一次循环时 将数据添加进图表中*/
                let seriesObj = {}; //临时存储
                let length_index = 0; //当前数据源中的value长度索引
                for (let length of dataList.value) {
                  if (length_index == 0) {
                    seriesObj = {
                      name: nameA + Math.random(),
                      type: 'line',
                      symbolSize: 9,
                      smooth: true,
                      seriesLayoutBy: 'row',
                      showSymbol: false,
                      hoverAnimation: false,
                      data: valueDataA
                    }
                  } else if (length_index == 1) {
                    seriesObj = {
                      name: nameB + Math.random(),
                      type: 'line',
                      symbolSize: 9,
                      smooth: true,
                      seriesLayoutBy: 'row',
                      showSymbol: false,
                      hoverAnimation: false,
                      data: valueDataB
                    }
                  } else if (length_index == 2) {
                    seriesObj = {
                      name: nameC + Math.random(),
                      type: 'line',
                      symbolSize: 9,
                      smooth: true,
                      seriesLayoutBy: 'row',
                      showSymbol: false,
                      hoverAnimation: false,
                      data: valueDataC
                    }
                  }
                  length_index++;
                  series.push(seriesObj)
                }

              }
            }

            resultIndex++;
            if (resultIndex == result.length) {
              resolve({
                series: series
              })
            }
          }

        })
      },

      /*表格 解决异步问题 调用产品物模型*/
      TableGetByDeviceCode(obj, resultD, ratio, place) {
        /*
         * obj => 当前数据集对象
         * resultD => 当前数据集历史记录单个对象
         * ratio => 当前数据集修正系数
         * place => 当前数据集保留小数位数
         */
        let self = this;
        return new Promise(async (resolve) => {
          let data = [];
          let attr = [];

          /*没数据的情况下*/
          if (JSON.stringify(resultD) == '[]' || JSON.stringify(resultD) == '{}') {
            resolve({
              attr: [],
              data: []
            })
            return;
          }

          let index = 0;
          for (let result of resultD){
            let featureList;
            let unit;
            let nameA = '';
            let nameB = '';
            let nameC = '';
            let name = '';
            if (result.deviceCode == 'SYSTEM_PROPERTY') {
              /*判断数据集历史记录的单个对象是否为系统属性*/
              unit = '';
              if (result.propertyCode.indexOf('_alarm_category_') != -1) {
                name = await self.getDictById(result.propertyCode.split('_alarm_category_')[1]);
              } else if (result.propertyCode.indexOf('_device_product_') != -1) {
                name = await self.getProductByCode(result.propertyCode.split('_device_product_')[1]);
              } else {
                name = self.system_options.filter(item => item.id == result.propertyCode)[0].name;
              }
            } else {
              /*不为系统属性时*/
              /*获取TSL 获取 数据属性名称*/
              featureList = await self.getProductFeature(result.deviceCode, result.propertyCode);
              let deviceName = await self.getDevice(result.deviceCode);
              name = deviceName ? featureList.name + '/' + deviceName : featureList.name;
              unit = featureList.dataType.specs.unit
            }
            /*配置图例名称后缀*/
            if (obj.function == 'pass') {
              nameA = name
            }else if (obj.function == 'add') {
              //nameA = '-求和'
              nameA = ' ';
            } else if (obj.function == 'growth') {
              unit = obj.unit;
              nameA = '增长量: '+name
              nameB = '增长率: '+name
            } else if (obj.function == 'time') {
              //nameA = '-持续时长'
              nameA = ' ';
            } else if (obj.function == 'sample') {
              unit = obj.unit;
              nameA = '最大值：'+name
              nameB = '最小值：'+name
              nameC = '平均值：'+name
            }

            if (!unit) {
              unit = '';
            }
            attr.push({
              nameA: nameA,
              nameB: nameB,
              nameC: nameC,
              unit: unit
            })

            /*如果是第一次进入 则在data创建新对象 如果是n次进入 则将值直接添加进已创建的data对象中*/
            if (index == 0) {
              for (let resultData of result.data) {
                let nameIndex = 0; //为了赋予函数后缀名而创建的索引
                let obj = {};
                obj.createdTime = resultData.time;
                for (let valueList of resultData.value) {
                  if (nameIndex == 0) {
                    if (valueList == null) {
                      obj[nameA] = null;
                    } else {
                      obj[nameA] = (valueList * ratio).toFixed(place)
                    }
                  } else if (nameIndex == 1) {
                    if (valueList == null) {
                      obj[nameB] = null
                    } else {
                      obj[nameB] = (valueList * ratio).toFixed(place)
                    }
                  } else if (nameIndex == 2) {
                    if (valueList == null) {
                      obj[nameC] = null
                    } else {
                      obj[nameC] = (valueList * ratio).toFixed(place)
                    }
                  }
                  nameIndex++;
                }
                data.push(obj);
              }
            } else {
              for (let resultData of result.data) {
                // for(let NowData of data) {
                // 	if(NowData.createdTime == resultData.time) {
                // 		let nameIndex = 0; //为了赋予函数后缀名而创建的索引
                // 		for(let valueList of resultData.value) {
                // 			if(nameIndex == 0) {
                // 				if(valueList == null){
                // 					NowData[nameA] = null;
                // 				}else{
                // 					NowData[nameA] = (valueList * ratio).toFixed(place);
                // 				}
                // 			} else if(nameIndex == 1) {
                // 				if(valueList == null){
                // 					NowData[nameB] = null;
                // 				}else{
                // 					NowData[nameB] = (valueList * ratio).toFixed(place);
                // 				}
                // 			} else if(nameIndex == 2) {
                // 				if(valueList == null){
                // 					NowData[nameC] = null;
                // 				}else{
                // 					NowData[nameC] = (valueList * ratio).toFixed(place);
                // 				}
                // 			}
                // 			nameIndex++;
                // 		}
                // 	}
                // }
                let NowData  = data.filter(i => i.createdTime == resultData.time)[0]
                if (NowData) {
                  let nameIndex = 0; //为了赋予函数后缀名而创建的索引
                  for (let valueList of resultData.value) {
                    if (nameIndex == 0) {
                      if (valueList == null) {
                        NowData[nameA] = null;
                      } else {
                        NowData[nameA] = (valueList * ratio).toFixed(place);
                      }
                    } else if (nameIndex == 1) {
                      if (valueList == null) {
                        NowData[nameB] = null;
                      } else {
                        NowData[nameB] = (valueList * ratio).toFixed(place);
                      }
                    } else if (nameIndex == 2) {
                      if (valueList == null) {
                        NowData[nameC] = null;
                      } else {
                        NowData[nameC] = (valueList * ratio).toFixed(place);
                      }
                    }
                    nameIndex++;
                  }
                } else {
                  NowData = {}
                  NowData.createdTime = resultData.time
                  let nameIndex = 0; //为了赋予函数后缀名而创建的索引
                  for (let valueList of resultData.value) {
                    if (nameIndex == 0) {
                      if (valueList == null) {
                        NowData[nameA] = null;
                      } else {
                        NowData[nameA] = (valueList * ratio).toFixed(place);
                      }
                    } else if (nameIndex == 1) {
                      if (valueList == null) {
                        NowData[nameB] = null;
                      } else {
                        NowData[nameB] = (valueList * ratio).toFixed(place);
                      }
                    } else if (nameIndex == 2) {
                      if (valueList == null) {
                        NowData[nameC] = null;
                      } else {
                        NowData[nameC] = (valueList * ratio).toFixed(place);
                      }
                    }
                    nameIndex++;
                  }
                  data.push(NowData);
                }
              }
            }
            index++;
            if (index == resultD.length) {
              resolve({
                attr: attr,
                data: data
              })
            }
          }
        })

      },

      /*格式化数据*/
      randomData(unit, now, value) {
        if (value == null) {
          value = [
            now,
            '-'
          ]
        } else {
          value = [
            //时间戳转时间的string 格式 => "1998/1/13" ; getMonth() + 1是为了去掉开头部分
            now,
            //该时间下的值
            value
          ]
        }
        now = this.common.timestampToTime(now);
        return {
          name: now,
          value: value,
          unit: unit,
        };
      },

      /*显示报表类型 更改*/
      chartsTypeChange(val) {

      },

      /*数字格式化
       s => 值
       n => 设置n个值时用逗号隔开
       * */
      fmoney(s, n) {
        let minus = false; //判断是否为负数
        n = n > 0 && n <= 20 ? n : 2;
        if (Number(s) < 0) {
          minus = true
          s = Number(String(s).split('-')[1])
        }
        s = parseFloat((s + "").replace(/[^\d\.-]/g, "")).toFixed(n) + "";
        var l = s.split(".")[0].split("").reverse(),
          r = s.split(".")[1];
        var t = "";
        for (let i = 0; i < l.length; i++) {
          t += l[i] + ((i + 1) % 3 == 0 && (i + 1) != l.length ? "," : "");
        }
        if (minus) {
          return '-' + t.split("").reverse().join("") + "." + r;
        } else {
          return t.split("").reverse().join("") + "." + r;
        }
      },

      /*导出*/
      exportClick() {
        // let idsa = [];
        // let index = 0;
        // let self = this;
        // for(let list of this.DataSetList) {
        // 	idsa.push(list.id);
        // 	index++;
        // 	if(index == this.DataSetList.length) {
        // 		/*导出数据集Execl*/
        // 		let NewIds = JSON.stringify(idsa).split('[')[1].split(']')[0]
        // 		self.get('/Dataset/exportReport', {
        // 			ids: NewIds,
        // 		}).then((res) => {

        // 		})
        // 	}
        // }
        console.log(this.tableList)
        // 创建表格
        var wb = XLSX.utils.book_new();
        for (let item of this.tableList) {
          let titleArr = ['时间'],
            dataArr = []
          for (let title of item.tableData.attr) {
            title.nameA&&titleArr.push(title.nameA)
            title.nameB&&titleArr.push(title.nameB)
            title.nameC&&titleArr.push(title.nameC)
          }
          for (let attr of item.tableData.data) {
            let valuearr = []
            // for (var key in attr) {
            //   if (key == 'createdTime') {
            //     valuearr.push(this.changeTime(attr[key]))
            //   } else {
            //     valuearr.push(attr[key])
            //   }
            // }
            for (var i in titleArr) {
              if(titleArr[i]=='时间'){
                valuearr[0]= this.changeTime2(attr['createdTime'],item.timeWindow)
              }else{
                valuearr[i] = attr[titleArr[i]] || ''
              }
            }
            dataArr.push(valuearr)
          }
          let titleArr2 = ['时间']
          for (let title of item.tableData.attr) {
            title.nameA&&titleArr2.push(title.unit ? title.nameA + '(' + title.unit + ')' : title.nameA)
            title.nameB&&titleArr2.push(title.unit ? title.nameB + '(' + title.unit + ')' : title.nameB)
            title.nameC&&titleArr2.push(title.unit ? title.nameC + '(' + title.unit + ')' : title.nameC)
          }
          dataArr.unshift(titleArr2)
          var obj = {
            name: item.name,
            dataArr: dataArr,
          }
          var ws = XLSX.utils.aoa_to_sheet(dataArr);
          XLSX.utils.book_append_sheet(wb, ws, item.name);
        }
        XLSX.writeFile(wb, this.changeTime(new Date().getTime()) + '.xlsx');
      },
      /*打印*/
      printClick() {
        //console.log(this.$refs.printRef.offsetHeight)
        // 转图片打印
        let that = this;
        var canvas2 = document.createElement("canvas");
        // let _canvas = document.getElementById('child');
        let _canvas = this.$refs.fatherPrint;
        var w = parseInt(window.getComputedStyle(_canvas).width);
        var h = parseInt(window.getComputedStyle(_canvas).height);
        //将canvas画布放大若干倍，然后盛放在较小的容器内，就显得不模糊了
        canvas2.width = w;
        canvas2.height = h;
        canvas2.style.width = w + "px";
        canvas2.style.height = h + "px";
        //可以按照自己的需求，对context的参数修改,translate指的是偏移量
        var context = canvas2.getContext("2d");
        //				context.scale(5, 5);
        html2canvas(this.$refs.fatherPrint, {
          canvas: canvas2
        }).then(function(canvas) {
          const url = canvas.toDataURL()
          //					console.log(url)
          printJS({
            printable: url,
            type: 'image',
            documentTitle: '打印图片'
          })
        });
        /*let top = this.$refs.fatherPrint.scrollTop;
        this.$refs.fatherPrint.scrollTop = 0

        html2canvas(this.$refs.print, {
        	backgroundColor: '#fff',
        	useCORS: true,
        	windowHeight: this.$refs.print.offsetHeight
        }).then((canvas) => {
        	//拍照之后 再打印
        	//let url = canvas.toDataURL('image/jpeg', 1.0)
        	const url = canvas.toDataURL()
        	this.img = url;
        	this.$nextTick(() => {
        		this.$print(document.getElementById('printa'))
        		this.$refs.fatherPrint.scrollTop = top;
        	})
        })*/
      },

    }
  }
</script>

<style scoped>
  .table_content>>>.el-table__body {
    width: 100% !important;
  }

  /*滚动条样式：谷歌浏览器下*/

  .table_content>>>.el-table__body-wrapper::-webkit-scrollbar {
    width: 8px;
    height: 8px;
    background-color: #f5f7fa;
  }

  /*滚动条的轨道*/

  .table_content>>>.el-table__body-wrapper::-webkit-scrollbar-track {
    /*box-shadow: inset 0 0 5px rgba(0,0,0,.3);*/
    background-color: #FAFAFA;
  }

  /*滚动条的滑块按钮*/

  .table_content>>>.el-table__body-wrapper::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #C2C2C2;
    /*box-shadow: inset 0 0 5px #000;*/
  }

  /*滚动条的上下两端的按钮*/

  .table_content>>>.el-table__body-wrapper::-webkit-scrollbar-button {
    height: 0px;
    width: 0px;
    /*background-color: #B0AEDA;*/
  }

  .overAuto {
    width: 100%;
    height: auto;
    margin-top: 20px;
  }

  .table_content>>>.el-table .has-gutter tr,
  .table_content>>>.el-table .has-gutter th {
    background-color: #eee !important;
    font-weight: 500;
    color: #2B2B2B;
  }

  .table_content>>>.el-table {
    border: 1px solid rgba(228, 228, 228, 1);
    border-radius: 5px;
    border-bottom: 0;
  }

  .table_content {
    float: left;
    width: 100%;
    /*height: calc(100% - 47px);*/
    /*margin-top: 20px;*/
  }

  .fig_content {
    float: left;
    width: 100%;
    height: calc(100% - 50px);
  }

  .title .title-border {
    width: 1px;
    height: 13px;
    position: absolute;
    left: 0;
    top: 0px;
    bottom: 0;
    margin: auto;
    border-left: 4px solid #00CCCD;
  }

  .title {
    float: left;
    width: 100%;
    text-indent: 14px;
    position: relative;
    line-height: 47px;
    /*font-weight: bold;*/
    font-family: 'MicrosoftYaHei';
    margin-bottom: 20px;
  }

  .tableCharts {
    float: left;
    width: calc(100% - 75px);
    /* height: 346px; */
    color: #2C2C2C;
    font-size: 15px;
    text-align: left;
    margin-bottom: 20px;
    margin-left: 38px;
    page-break-after: always
  }

  .pielist {
    width: calc(50% - 76px) !important;
  }

  .figCharts:nth-child(even) {
    width: calc(100% - 76px);
    float: left;
    /* margin-right: 78px; */
    height: 325px;
    color: #2C2C2C;
    font-size: 15px;
    text-align: left;
    margin-left: 38px;
    page-break-after: always;
    margin-right: 38px;
    margin-bottom: 20px;
  }

  .figCharts:nth-child(odd) {
    float: left;
    width: calc(100% - 76px);
    height: 325px;
    color: #2C2C2C;
    font-size: 15px;
    text-align: left;
    margin-left: 38px;
    page-break-after: always;
    margin-right: 38px;
    margin-bottom: 20px;
  }

  .Figure,
  .Table {
    width: 100%;
    /*height: calc(100% - 144px);*/
    float: left;
    /*margin-top: 20px;*/
    page-break-after: always
  }

  .charts_content::-webkit-scrollbar {
    width: 8px;
    height: 8px;
    background-color: #f5f7fa;
  }

  /*滚动条的轨道*/

  .charts_content::-webkit-scrollbar-track {
    /*box-shadow: inset 0 0 5px rgba(0,0,0,.3);*/
    background-color: #eee;
  }

  /*滚动条的滑块按钮*/

  .charts_content::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #D2D2D2;
    /*box-shadow: inset 0 0 5px #000;*/
    /*box-shadow: 8px 0 0 #A5ADB7 inset;*/
  }

  /*滚动条的上下两端的按钮*/

  .charts_content::-webkit-scrollbar-button {
    height: 10px;
    background-color: #eee;
  }

  .charts_content {
    /*width: 21cm;
		position: relative;
		overflow-y: auto;
		overflow-x: hidden;
		left: 0;
		right: 0;
		margin: auto;
		background: #fff;
		min-height: 29.7cm;*/
    width: 21cm;
    position: absolute;
    /* overflow-y: auto; */
    /* overflow-x: hidden; */
    left: 0;
    right: 0;
    margin: auto;
    background: #fff;
    min-height: 29.7cm;
    top: 76px;
  }

  .print {
    background: url(../../assets/image/createdExecl/print.png)no-repeat left;
  }

  .export {
    background: url(../../assets/image/createdExecl/export.png)no-repeat left;
    margin-right: 23px;
  }

  .export,
  .print {
    cursor: pointer;
    width: 48px;
    text-align: right;
    float: left;
  }

  .header_content .right .right_right {
    float: left;
    color: #5087E4;
  }

  .header_content .right .right_left {
    float: left;
    margin-right: 85px;
  }

  .header_content .left {
    float: left;
    color: #363636;
    font-size: 14px;
    margin-left: 53px;
  }

  .header_content .right {
    float: right;
    padding-right: 126px;
    font-size: 13px;
  }

  .header_content {
    width: 100%;
    float: left;
    text-align: left;
  }

  #createdCharts_header_right>>>.el-radio__inner::after {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #5087E4;
    border: 1px solid #fff;
  }

  #createdCharts_header_right>>>.el-radio__input.is-checked .el-radio__inner {
    background: #5087E4 !important;
    border-color: #5087E4 !important;
  }

  #createdCharts_header_right>>>.el-radio__inner {
    border: 2px solid rgba(191, 191, 191, 1);
    width: 16px;
    height: 16px;
  }

  #createdCharts_header_right>>>.el-radio__input.is-checked+.el-radio__label {
    color: #373737 !important;
  }

  .header_content .right {
    text-align: left;
  }

  .createdCharts .charts_header {
    width: 100%;
    height: 75px;
    float: left;
    border-bottom: 1px solid #D8D8D8;
    line-height: 75px;
    background: #fff;
  }

  .createdCharts {
    width: 100%;
    /*height: 100%;*/
    position: relative;
    background-color: #eee;
  }

  .charts_header .closediv {
    float: right;
    position: relative;
    margin-right: 25px;
    margin-top: 12px;
    width: 2rem;
    height: 2rem;
    cursor: pointer;
  }

  .charts_header .close {
    position: absolute;
    width: 0.2em;
    height: 1.3em;
    background: #777777;
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
    display: inline-block;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
  }

  .charts_header .close:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 0.2em;
    height: 1.3em;
    background: #777777;
    -webkit-transform: rotate(270deg);
    -moz-transform: rotate(270deg);
    -o-transform: rotate(270deg);
    -ms-transform: rotate(270deg);
    transform: rotate(270deg);
  }

  * {
    -webkit-touch-callout: none;
    /*系统默认菜单被禁用*/
    -webkit-user-select: none;
    /*webkit浏览器*/
    -khtml-user-select: none;
    /*早期浏览器*/
    -moz-user-select: none;
    /*火狐*/
    -ms-user-select: none;
    /*IE10*/
    user-select: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dataset/CreatedCharts.vue